// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Viewer Page component
 */
import React, { Component, PropTypes } from 'react';
import { Router } from 'react-router';
import { Integration } from 'config';
import getHistory from '../Izenda.History';
import routeUtils from '../share/utils/Izenda.RouteUtils';
import IntegrationRoutes from '../routes/Izenda.IntegrationRoutes';
import subReportLink from '../share/utils/Izenda.SubReportLink';

export default class ReportViewerPage extends Component {
  static propTypes = {
    reportId: PropTypes.string,
    filter: PropTypes.object
  };

  constructor(props: any) {
    super(props);

    const { reportId, filter } = props;
    this.history = getHistory(Integration);
    if (!Integration) return;
    routeUtils.listenHistoryChange(
      this.history,
      this.getReportViewerRoute(reportId, filter).path,
      this.getQuery(filter)
    );
  }

  /**
   * Get report viewer route
   * @param {String} reportId
   * @param {Object} filter
   */
  getReportViewerRoute(reportId: string, filter: any): any {
    return {
      path: routeUtils.getReportViewerUrl('ReportViewerDetail', { id: reportId }),
      query: this.getQuery(filter)
    };
  }

  /**
   * Get query
   * @param {Object} filter
   */
  getQuery(filter: any): any {
    return subReportLink.convertFilterToQuery(filter);
  }

  /**
   * Change url
   * @param {Object} nextProps
   */
  changeUrl(nextProps: any): void {
    const { reportId, filter } = nextProps;

    if (reportId) {
      const reportViewerRoute = this.getReportViewerRoute(reportId, filter);
      const { path: reportLink, query } = reportViewerRoute;
      query.forceUpdate = true;
      const queryString = $izenda.param(query);

      this.history.push(`${reportLink}?${queryString}`);
    }
  }

  componentWillReceiveProps(nextProps: any) {
    this.changeUrl(nextProps);
  }

  render() {
    const { reportId, filter } = this.props;
    const reportViewerRoute = this.getReportViewerRoute(reportId, filter);
    const { synergyHistory } = this.history;

    return <Router history={synergyHistory}>{IntegrationRoutes(reportViewerRoute)}</Router>;
  }
}



// WEBPACK FOOTER //
// ./ui/pages/Izenda.ReportViewerPage.js